import { ListedInstrument, OrderExchangeData, isDefined } from '@eih-netbroker/common';
import { ValidatedOrder } from '../../services/order/useNormalOrderView';
import { CapturedExchangeData, OrderFormSourceComponent } from '../../types/orderTypes';
import { OrderFormData } from '../order/OrderForm';
import { OrderWarningConfirm } from '../order/OrderWarningConfirm';
import { useOrderState } from '../OrderStateContext';
import { OrderConfirm } from './order-confirm/OrderConfirm';
import { OrderForm2, PriceValidationState } from './order-form/OrderForm2';

type OrderModalContentProps = {
  orderState: OrderFormData;
  exchangeData?: OrderExchangeData;
  capturedExchangeData?: CapturedExchangeData;
  updateOrderState: (order: OrderFormData) => void;
  changeInstrument: (instrument: ListedInstrument | null) => void;
  onStopActivationPriceRevalidate: (order: OrderFormData) => Promise<void>;
  priceValidationState?: PriceValidationState;
  stopActivationPriceValidationState?: PriceValidationState;
  orderId?: string;
  orderRequestLoading: boolean;
  isWidget?: boolean;
  initialOrder: ValidatedOrder | null;
  isOrderFormDetailsExpanded?: boolean;
  sourceComponent: OrderFormSourceComponent;
  onBack: (shouldResetFormToDefaults: boolean) => void;
};

export const OrderModalContent = ({
  orderState,
  updateOrderState,
  exchangeData,
  capturedExchangeData,
  changeInstrument,
  onStopActivationPriceRevalidate,
  priceValidationState,
  stopActivationPriceValidationState,
  orderId,
  orderRequestLoading,
  isOrderFormDetailsExpanded,
  sourceComponent,
  onBack,
}: OrderModalContentProps) => {
  const { tempOrder, warnings } = useOrderState();

  if (!tempOrder && !warnings) {
    return (
      <OrderForm2
        isModify={isDefined(orderId)}
        order={orderState}
        priceValidationState={priceValidationState}
        stopActivationPriceValidationState={stopActivationPriceValidationState}
        onChange={updateOrderState}
        onStopActivationPriceRevalidate={onStopActivationPriceRevalidate}
        exchangeData={exchangeData}
        onInstrumentChange={changeInstrument}
        orderRequestLoading={orderRequestLoading}
        isOrderFormDetailsExpanded={isOrderFormDetailsExpanded}
        sourceComponent={sourceComponent}
      />
    );
  }

  if (warnings) {
    return <OrderWarningConfirm messages={warnings ?? []} />;
  }

  if (tempOrder) {
    if (tempOrder.showWarningConfirmation) {
      return <OrderWarningConfirm messages={tempOrder.messages ?? []} />;
    }

    if (tempOrder.showConfirmation) {
      return (
        <OrderConfirm
          orderForm={orderState as ValidatedOrder}
          capturedExchangeData={capturedExchangeData}
          onBack={onBack}
        />
      );
    }
  }
};
